import React from 'react';
import { Layout } from 'antd';
import CommonHeader from "../components/commonHeader";
import { Outlet } from "react-router-dom";
import styles from './main.module.css';

const { Content } = Layout;

const MainLayout = () => {
    return (
        <Layout className={styles.container}>
            <CommonHeader />
            <Content className={styles.content}>
                <Outlet />
            </Content>
        </Layout>
    );
}

export default MainLayout;